// Whiteboard — what a pointer on the board is: the pen's tip, the pen's
// eraser end, a fingertip, or a hand resting on the screen. Plain JS — the
// suite runs it in Node.
//
// Drawing with a pen, the hand rests on the screen. Before this the board took
// that hand for a finger: it moved the view under the pen, or made a pinch of
// hand + pen, and the stroke was lost. Now, once a pen has been used on a
// device, only the pen draws (a person may turn finger drawing back on); a
// touch while the pen is on or near the screen is never heard at all; and a
// touch the size of a palm is not a finger.

export const PEN_NEAR_MS = 900;   // a touch this soon after the pen was near the screen is the hand holding it
export const PALM_PX = 60;        // a contact this wide or tall (CSS px) is a palm, not a fingertip

// The pen's other end (a Surface pen, a Wacom stylus): the browser reports it
// as the pen with its eraser button — button 5 as it touches, buttons bit 32
// while it rubs.
export const isEraserEnd = (e) => !!e && e.pointerType === 'pen' && (e.button === 5 || ((e.buttons || 0) & 32) === 32);

export const isPalm = (e) => !!e && e.pointerType === 'touch' && (Number(e.width) >= PALM_PX || Number(e.height) >= PALM_PX);

// What a pointer pressed on the board is:
//   'tool'    the pen's tip or a mouse (or a finger, when fingers draw): the tool picked on the rail
//   'eraser'  the pen's eraser end: rubs out, whatever tool is picked — turned back, the pen has its tool again
//   'finger'  a fingertip when only the pen draws: two of them move and zoom the view, one alone does nothing
//            (with the Move the view tool, one moves the view)
//   'ignore'  a hand resting on the screen: the board takes no notice of it
// state: touchDraws — fingers draw (no pen used on this device, or the person
// turned it on); penDown — the pen is on the screen; penAt / now — when the
// pen was last near it (hovering, touching, lifting) and the time now (ms).
export function pointerRole(e, { touchDraws = true, penDown = false, penAt = -Infinity, now = 0 } = {}) {
  if (!e) return 'ignore';
  if (e.pointerType === 'pen') return isEraserEnd(e) ? 'eraser' : 'tool';
  if (e.pointerType !== 'touch') return 'tool';
  if (penDown || now - penAt < PEN_NEAR_MS) return 'ignore';
  if (touchDraws) return 'tool';   // fingers draw (a phone): a fat fingertip on a zoomed-out page is still a finger
  return isPalm(e) ? 'ignore' : 'finger';
}
